import { createAxiosInstance } from "@moodys/mdc-frontend.services.fetcher";
import { logger } from "@moodys/mdc-frontend.services.logger";

export const shellClient = createAxiosInstance({
  baseURL: process.env.SHELL_API_URL || "/shell/api",
});

export interface UserProductsAuthorizations {
  dlAuthorized: boolean;
  pssAuthorized: boolean;
  dssAuthorized: boolean;
  monitoringAuthorized: boolean;
}

export const fetchUserProductsAuthorizations = async (): Promise<
  UserProductsAuthorizations | undefined
> => {
  try {
    const response =
      await shellClient.get<UserProductsAuthorizations>("/user-products");
    return response.data;
  } catch (error) {
    logger.error({ error, message: "User products fetch failed" });
    return;
  }
};

export interface LiveChatInfo {
  enabled: boolean;
  insiteId?: string;
}

export const fetchLiveChatInfo = async (): Promise<
  LiveChatInfo | undefined
> => {
  try {
    const response = await shellClient.get<LiveChatInfo>("/live-chat-info");
    return response.data;
  } catch (error) {
    logger.error({ error, message: "Live chat info fetch failed" });
    return;
  }
};
